/**
 * React component that is responsible for rendering a link card.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react';
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import Typography from 'components/theme/Typography';
import styles from './LinkCard.module.scss'

const LinkCard = ({
  children,
  ...props
}) => (
  <a {...props}>
    <Typography className={cx(styles.linkCard)} variant="h2">
      <span className={cx(styles.linkText)}>{children}</span>
      <span><FontAwesomeIcon icon={faChevronRight} /></span>
    </Typography>
  </a>
)

LinkCard.propTypes = {
  children: PropTypes.node,
}

export default LinkCard
